import { useState } from 'react'
import type { PortalReferral } from '@/services/referralsService'
import { ParceirosAppShell } from './ParceirosAppShell'
import { ParceirosImportModal } from './ParceirosImportModal'
import { ParceirosIndicacoesTable } from './ParceirosIndicacoesTable'
import { ParceirosLeadEditModal } from './ParceirosLeadEditModal'
import { ParceirosLeadForm } from './ParceirosLeadForm'
import { PARCEIROS_ACCENT } from './parceirosBrand'
import { parceirosLeadMetrics } from './parceirosLeadMetrics'
import { useParceirosLeads } from './useParceirosLeads'

export default function ParceirosIndicacoes() {
  const [page, setPage] = useState(1)
  const { rows, total, totalPages, byStatus, error, loading, reload, pageSize } = useParceirosLeads(page)
  const [showForm, setShowForm] = useState(false)
  const [showImport, setShowImport] = useState(false)
  const [editing, setEditing] = useState<PortalReferral | null>(null)
  const metrics = parceirosLeadMetrics(total, byStatus)

  function refreshFromStart() {
    if (page === 1) void reload()
    else setPage(1)
  }

  return (
    <ParceirosAppShell title='Indicações'>
      <div className='grid gap-6'>
        <div className='flex flex-wrap items-end justify-between gap-3'>
          <div>
            <h2 className='text-2xl font-black text-text-primary'>Indicações</h2>
            <p className='mt-1 text-sm text-text-muted'>Cadastre um lead ou acompanhe o status de cada indicação.</p>
          </div>
          <div className='flex flex-wrap gap-2'>
            <button
              type='button'
              onClick={() => setShowForm((open) => !open)}
              className='rounded-full px-4 py-2 text-sm font-medium text-white active:scale-95'
              style={{ background: PARCEIROS_ACCENT }}
            >
              {showForm ? 'Fechar cadastro' : 'Nova indicação'}
            </button>
            <button
              type='button'
              onClick={() => setShowImport(true)}
              className='rounded-full border border-[var(--glass-border)] px-4 py-2 text-sm text-text-muted hover:text-text-primary'
            >
              Importar
            </button>
          </div>
        </div>

        <div className='grid grid-cols-2 gap-3 lg:grid-cols-4'>
          {metrics.map((item) => (
            <div key={item.label} className='rounded-2xl border border-[var(--glass-border)] bg-[var(--bg-card)] px-4 py-3'>
              <p className='text-[11px] font-medium uppercase tracking-wider text-text-muted'>{item.label}</p>
              <p className='mt-1 text-2xl font-black text-text-primary'>{loading && total === 0 ? '—' : item.value}</p>
            </div>
          ))}
        </div>

        {error && <p className='text-sm text-red-300'>{error}</p>}
        {showForm && <ParceirosLeadForm onCreated={refreshFromStart} />}
        <ParceirosIndicacoesTable
          rows={rows}
          loading={loading}
          page={page}
          pageSize={pageSize}
          total={total}
          totalPages={totalPages}
          onPage={setPage}
          onOpen={setEditing}
        />
        <ParceirosLeadEditModal row={editing} onClose={() => setEditing(null)} onSaved={reload} />
        <ParceirosImportModal open={showImport} onClose={() => setShowImport(false)} onImported={refreshFromStart} />
      </div>
    </ParceirosAppShell>
  )
}
